import {
  boleto_Generator,
  Method_POST,
  Method_POST_REST,
  Method_POST_CONTEXTO,
  pix_Generator,
  POST_Remove_arquivo_context,
} from "../../../../../service/api";

/** Consulta os dados completos de uma OS. */
export function consultarOS(numeroSolicitacao) {
  return Method_POST("/ordem-servico/consultar2", { id: numeroSolicitacao });
}

/** Lista os documentos anexados diretamente na OS. */
export function listarDocumentosOS(idOrdem) {
  return Method_POST("/ordem-servico/documento/listar", { id: idOrdem });
}

/** Lista os documentos do cliente em "contexto" (área do cliente). */
export function listarDocumentosContexto() {
  return Method_POST_CONTEXTO("/cliente/arquivo/listar");
}

/** Confere se o cliente já tem contexto (histórico de arquivos) no sistema. */
export function consultarContextoCliente(idCliente) {
  return Method_POST("/cliente/contexto", { id: idCliente });
}

export function removerArquivoContexto(nomeArquivo) {
  return POST_Remove_arquivo_context(
    `/cliente/arquivo/remover?filename=${encodeURIComponent(nomeArquivo)}`
  );
}

export function avancarOSApi(idOrdem) {
  return Method_POST("/ordem-servico/avancar", { id: idOrdem });
}

export function retrocederOSApi(idOrdem) {
  return Method_POST("/ordem-servico/retroceder", { id: idOrdem });
}

export function suspenderOSApi(idOrdem) {
  return Method_POST("/ordem-servico/suspender", { id: idOrdem });
}

export function restaurarOSApi(idOrdem) {
  return Method_POST("/ordem-servico/restaurar", { id: idOrdem });
}

export function cancelarOSApi(idOrdem) {
  return Method_POST("/ordem-servico/cancelar", { id: idOrdem });
}

export function negociarOSApi(idOrdem, situacaoId) {
  return Method_POST("/ordem-servico/negociar", { id: idOrdem, situacao: { id: situacaoId } });
}

export function desnegociarOSApi(idOrdem, situacaoId) {
  return Method_POST("/ordem-servico/desnegociar", { id: idOrdem, situacao: { id: situacaoId } });
}

export function confirmarConselhoApi(numeroSolicitacao, dias, motivo) {
  return Method_POST_REST("/ordem-servico/conselho", {
    ordem: { id: numeroSolicitacao },
    dias,
    motivo,
  });
}

export function gerarPixApi(numeroSolicitacao) {
  return pix_Generator("/pix/checkout", { id: numeroSolicitacao, securityToken: "portal" });
}

export function gerarBoletoApi(numeroSolicitacao) {
  return boleto_Generator("/checkout", { id: numeroSolicitacao, securityToken: "portal" });
}

export function consultarSituacaoFiscalApi(idCliente, cnpjEmpresa) {
  return Method_POST_CONTEXTO("empresa/retrieve/sitifis", {
    id: idCliente,
    cnpj: cnpjEmpresa,
    sysProvedorSincronismo: "SERPRO",
  });
}
